import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg, imgUrl, timeAgo } from "@/lib/api";
import { Loading, Empty, ErrorState, PageTitle, StatusPill } from "@/components/States";
import { btnPrimary } from "@/lib/ui";

export default function Inbox() {
  const [convs, setConvs] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("all");
  const load = useCallback(() => {
    api.get("/conversations").then(({ data }) => setConvs(data)).catch((e) => setErr(errMsg(e)));
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  const shown = convs?.filter((c) => tab === "all" || c.role === tab);
  return (
    <div className="max-w-3xl">
      <PageTitle sub="Every conversation is tied to a listing.">Inbox</PageTitle>
      <div className="flex gap-1 p-1 rounded-xl bg-slate-100 w-fit mb-4">
        {[["all", "All"], ["buyer", "Buying"], ["seller", "Selling"]].map(([k, v]) => (
          <button key={k} data-testid={`inbox-tab-${k}`} onClick={() => setTab(k)} className={`px-4 h-9 rounded-lg text-sm font-semibold ${tab === k ? "bg-white shadow-sm" : "text-slate-500"}`}>{v}</button>
        ))}
      </div>
      {err ? <ErrorState message={err} onRetry={load} /> : !convs ? <Loading /> : shown.length === 0 ? (
        <Empty title="No conversations yet" body="When you ask a question, make an offer, or request a pickup, it shows up here." action={<Link to="/" className={btnPrimary}>Browse items</Link>} />
      ) : (
        <div className="bg-white border border-slate-200 rounded-2xl divide-y divide-slate-100 overflow-hidden">
          {shown.map((c) => (
            <Link key={c.id} to={`/inbox/${c.id}`} data-testid={`conversation-row-${c.id}`} className="flex items-center gap-3 p-3 sm:p-4 hover:bg-slate-50 transition-colors">
              <div className="h-14 w-14 rounded-xl bg-slate-100 overflow-hidden shrink-0">
                {c.listing?.photos?.[0] && <img src={imgUrl(c.listing.photos[0])} alt="" className="h-full w-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className={`truncate text-sm ${c.unread ? "font-extrabold text-slate-900" : "font-semibold text-slate-800"}`}>{c.other_user?.first_name} · {c.listing?.title}</p>
                  {c.listing && c.listing.status !== "active" && <StatusPill status={c.listing.status} />}
                </div>
                <p className={`truncate text-sm ${c.unread ? "text-slate-900" : "text-slate-500"}`}>{c.last_message}</p>
              </div>
              <div className="flex flex-col items-end gap-1 shrink-0">
                <span className="text-xs text-slate-400">{timeAgo(c.last_message_at)}</span>
                {c.unread > 0 && <span data-testid={`conversation-unread-${c.id}`} className="h-5 min-w-5 px-1.5 rounded-full bg-blue-600 text-white text-[10px] font-bold flex items-center justify-center">{c.unread}</span>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
